/**
 * OrientationFrame renders a fixed 3-axis reference frame
 * aligned with global/world coordinates.
 */
export function OrientationFrame() {
  // Half of previous axis length (1.2 -> 0.6) and no arrow tips.
  return <axesHelper args={[0.6]} />
}
